import { UserWayMemberRole } from '../constants/userway-integration';
import { SsoAccessCodeDtoInterface } from './userway/sso/sso-access-code-dto.interface';

export interface IUserWayOrganization {
  organizationId: string;
  organizationName: string;
  userwayAccountCode: string;
  state: boolean;
  sites: IUserWaySite[];
  teamMembers: IUserWayOrganizationMembers[];
}

export interface IUserWaySite {
  hostName: string;
}

export interface IUserWayOrganizationMembers {
  email: string;
  firstName: string;
  lastName: string;
  hostNames: string[];
}

export interface IUserWayPayloadResponse<T> {
  payload: T;
  payloadType: string;
}

export type IUserWayVoidResponse = IUserWayPayloadResponse<Record<string, never>>;

export type IUserWayUpsertOrganizationResponse = IUserWayPayloadResponse<IUserWayOrganization | Record<string, never>>;

export interface IUserWayUpsertOrganizationRequest {
  organizationId: string;
  organizationName: string;
  state?: boolean;
  environmentBaseUrl?: string;
}

export interface IUserWaySiteMemberIdentity {
  organizationId: string;
  email: string;
}

interface IUserWaySiteMemberProperties {
  firstName: string;
  lastName: string;
  role: UserWayMemberRole;
  hostNames: string[];
}

export interface IUserWayAddSiteMemberRequest extends IUserWaySiteMemberProperties, IUserWaySiteMemberIdentity {}

export interface IUserWayUpdateSiteMemberRequest extends Partial<IUserWaySiteMemberProperties>, IUserWaySiteMemberIdentity {}

export interface IUserWayUpsertOrganizationSiteRequest {
  organizationId: string;
  hostNames: string[];
}

export interface IUserWayOrganizationAuthRequest {
  organizationId: string;
  email: string;
  targetAccountCode?: string;
  target?: UserWayOrganizationAuthRequestTarget;
}

export enum UserWayOrganizationAuthRequestTarget {
  WIDGET = 'widget',
  DASHBOARD = 'dashboard',
}

export type IUserWayOrganizationAuthResponse = IUserWayPayloadResponse<{
  tempToken: string;
  redirectUrl: string;
}>;

export interface IUserWaySSOLink {
  ssoLink: string;
}

export interface IUserWayAccountData {
  userEmail: string;
  targetAccountCode: string;
}

export interface IUserWayAccountCode {
  accountCode: string;
}

export interface IUserWayTenantIntegration {
  enabled: boolean;
}

export type IUserWayLoginTargetAccountResponse = IUserWayPayloadResponse<SsoAccessCodeDtoInterface>;
